// source: pbtypes/util/pathfinder/pathfinder_metadata.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.pathfinder.PathfinderArtifactMetadata', null, global);
goog.exportSymbol('proto.pathfinder.PathfinderArtifactSettings', null, global);
goog.exportSymbol('proto.pathfinder.PathfinderVersion', null, global);
goog.exportSymbol('proto.pathfinder.PathfinderVersion.ArtifactMajorVersion', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pathfinder.PathfinderVersion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pathfinder.PathfinderVersion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pathfinder.PathfinderVersion.displayName = 'proto.pathfinder.PathfinderVersion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pathfinder.PathfinderArtifactSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pathfinder.PathfinderArtifactSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pathfinder.PathfinderArtifactSettings.displayName = 'proto.pathfinder.PathfinderArtifactSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pathfinder.PathfinderArtifactMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pathfinder.PathfinderArtifactMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pathfinder.PathfinderArtifactMetadata.displayName = 'proto.pathfinder.PathfinderArtifactMetadata';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pathfinder.PathfinderVersion.prototype.toObject = function(opt_includeInstance) {
  return proto.pathfinder.PathfinderVersion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pathfinder.PathfinderVersion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pathfinder.PathfinderVersion.toObject = function(includeInstance, msg) {
  var f, obj = {
major: jspb.Message.getFieldWithDefault(msg, 2, 0),
minor: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pathfinder.PathfinderVersion}
 */
proto.pathfinder.PathfinderVersion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pathfinder.PathfinderVersion;
  return proto.pathfinder.PathfinderVersion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pathfinder.PathfinderVersion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pathfinder.PathfinderVersion}
 */
proto.pathfinder.PathfinderVersion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {!proto.pathfinder.PathfinderVersion.ArtifactMajorVersion} */ (reader.readEnum());
      msg.setMajor(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinor(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pathfinder.PathfinderVersion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pathfinder.PathfinderVersion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pathfinder.PathfinderVersion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pathfinder.PathfinderVersion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMajor();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMinor();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pathfinder.PathfinderVersion.ArtifactMajorVersion = {
  UNKNOWN: 0,
  VERSION_1: 1,
  VERSION_2: 2
};

/**
 * optional ArtifactMajorVersion major = 2;
 * @return {!proto.pathfinder.PathfinderVersion.ArtifactMajorVersion}
 */
proto.pathfinder.PathfinderVersion.prototype.getMajor = function() {
  return /** @type {!proto.pathfinder.PathfinderVersion.ArtifactMajorVersion} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pathfinder.PathfinderVersion.ArtifactMajorVersion} value
 * @return {!proto.pathfinder.PathfinderVersion} returns this
 */
proto.pathfinder.PathfinderVersion.prototype.setMajor = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 minor = 3;
 * @return {number}
 */
proto.pathfinder.PathfinderVersion.prototype.getMinor = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pathfinder.PathfinderVersion} returns this
 */
proto.pathfinder.PathfinderVersion.prototype.setMinor = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.pathfinder.PathfinderArtifactSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pathfinder.PathfinderArtifactSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pathfinder.PathfinderArtifactSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
targetExtentWgs84Wkt: jspb.Message.getFieldWithDefault(msg, 1, ""),
organizationUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
dstResolutionWgs84: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
shieldAvoidRadius: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
floorAgl: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
obstacleRadius: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
slicesHeightStep: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
slicesHeightMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
slicesHeightMax: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
separateGeospatialOrgFiles: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
slicesVectorGeometryTolerance: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
fullDtedTiles: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pathfinder.PathfinderArtifactSettings}
 */
proto.pathfinder.PathfinderArtifactSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pathfinder.PathfinderArtifactSettings;
  return proto.pathfinder.PathfinderArtifactSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pathfinder.PathfinderArtifactSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pathfinder.PathfinderArtifactSettings}
 */
proto.pathfinder.PathfinderArtifactSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTargetExtentWgs84Wkt(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOrganizationUuid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDstResolutionWgs84(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setShieldAvoidRadius(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setFloorAgl(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setObstacleRadius(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSlicesHeightStep(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSlicesHeightMin(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSlicesHeightMax(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSeparateGeospatialOrgFiles(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setSlicesVectorGeometryTolerance(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFullDtedTiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pathfinder.PathfinderArtifactSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pathfinder.PathfinderArtifactSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pathfinder.PathfinderArtifactSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetExtentWgs84Wkt();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrganizationUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDstResolutionWgs84();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getShieldAvoidRadius();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getFloorAgl();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getObstacleRadius();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getSlicesHeightStep();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getSlicesHeightMin();
  if (f !== 0.0) {
    writer.writeFloat(
      8,
      f
    );
  }
  f = message.getSlicesHeightMax();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getSeparateGeospatialOrgFiles();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getSlicesVectorGeometryTolerance();
  if (f !== 0.0) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = message.getFullDtedTiles();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional string target_extent_wgs84_wkt = 1;
 * @return {string}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getTargetExtentWgs84Wkt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setTargetExtentWgs84Wkt = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string organization_uuid = 2;
 * @return {string}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getOrganizationUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setOrganizationUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional float dst_resolution_wgs84 = 3;
 * @return {number}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getDstResolutionWgs84 = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setDstResolutionWgs84 = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float shield_avoid_radius = 4;
 * @return {number}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getShieldAvoidRadius = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setShieldAvoidRadius = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float floor_agl = 5;
 * @return {number}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getFloorAgl = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setFloorAgl = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float obstacle_radius = 6;
 * @return {number}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getObstacleRadius = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setObstacleRadius = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional float slices_height_step = 7;
 * @return {number}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getSlicesHeightStep = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setSlicesHeightStep = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional float slices_height_min = 8;
 * @return {number}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getSlicesHeightMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setSlicesHeightMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional float slices_height_max = 9;
 * @return {number}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getSlicesHeightMax = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setSlicesHeightMax = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional bool separate_geospatial_org_files = 10;
 * @return {boolean}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getSeparateGeospatialOrgFiles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setSeparateGeospatialOrgFiles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional float slices_vector_geometry_tolerance = 11;
 * @return {number}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getSlicesVectorGeometryTolerance = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setSlicesVectorGeometryTolerance = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional bool full_dted_tiles = 12;
 * @return {boolean}
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.getFullDtedTiles = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pathfinder.PathfinderArtifactSettings} returns this
 */
proto.pathfinder.PathfinderArtifactSettings.prototype.setFullDtedTiles = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.pathfinder.PathfinderArtifactMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pathfinder.PathfinderArtifactMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pathfinder.PathfinderArtifactMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
organizationFileUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
version: (f = msg.getVersion()) && proto.pathfinder.PathfinderVersion.toObject(includeInstance, f),
settings: (f = msg.getSettings()) && proto.pathfinder.PathfinderArtifactSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pathfinder.PathfinderArtifactMetadata}
 */
proto.pathfinder.PathfinderArtifactMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pathfinder.PathfinderArtifactMetadata;
  return proto.pathfinder.PathfinderArtifactMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pathfinder.PathfinderArtifactMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pathfinder.PathfinderArtifactMetadata}
 */
proto.pathfinder.PathfinderArtifactMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOrganizationFileUuid(value);
      break;
    case 2:
      var value = new proto.pathfinder.PathfinderVersion;
      reader.readMessage(value,proto.pathfinder.PathfinderVersion.deserializeBinaryFromReader);
      msg.setVersion(value);
      break;
    case 3:
      var value = new proto.pathfinder.PathfinderArtifactSettings;
      reader.readMessage(value,proto.pathfinder.PathfinderArtifactSettings.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pathfinder.PathfinderArtifactMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pathfinder.PathfinderArtifactMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pathfinder.PathfinderArtifactMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationFileUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pathfinder.PathfinderVersion.serializeBinaryToWriter
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.pathfinder.PathfinderArtifactSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional string organization_file_uuid = 1;
 * @return {string}
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.getOrganizationFileUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pathfinder.PathfinderArtifactMetadata} returns this
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.setOrganizationFileUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PathfinderVersion version = 2;
 * @return {?proto.pathfinder.PathfinderVersion}
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.getVersion = function() {
  return /** @type{?proto.pathfinder.PathfinderVersion} */ (
    jspb.Message.getWrapperField(this, proto.pathfinder.PathfinderVersion, 2));
};


/**
 * @param {?proto.pathfinder.PathfinderVersion|undefined} value
 * @return {!proto.pathfinder.PathfinderArtifactMetadata} returns this
*/
proto.pathfinder.PathfinderArtifactMetadata.prototype.setVersion = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pathfinder.PathfinderArtifactMetadata} returns this
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.clearVersion = function() {
  return this.setVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PathfinderArtifactSettings settings = 3;
 * @return {?proto.pathfinder.PathfinderArtifactSettings}
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.getSettings = function() {
  return /** @type{?proto.pathfinder.PathfinderArtifactSettings} */ (
    jspb.Message.getWrapperField(this, proto.pathfinder.PathfinderArtifactSettings, 3));
};


/**
 * @param {?proto.pathfinder.PathfinderArtifactSettings|undefined} value
 * @return {!proto.pathfinder.PathfinderArtifactMetadata} returns this
*/
proto.pathfinder.PathfinderArtifactMetadata.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pathfinder.PathfinderArtifactMetadata} returns this
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pathfinder.PathfinderArtifactMetadata.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.pathfinder);
